<template>
  <card v-if="loaded" extra-classes="bg-white px-4 py-5 sm:px-6">
    <h2 id="nurture-title" class="text-lg font-medium text-gray-900">Onboarding Tasks</h2>
    <div class="mt-4">
      <ul class="grid grid-cols-1 gap-4">
        <li v-for="info in progressByAssignee" class="flex justify-between items-center">
          <span class="flex flex-col items-start">
            <span class="text-gray-900">{{ displayName(info) }}</span>
            <span class="text-gray-500 text-sm">({{ info.completed }}/{{ info.total }} tasks completed)</span></span
          >
          <RadialProgress style="--size: 2rem; font-size: 0.5rem" :progress="percentage(info)" />
        </li>
      </ul>
    </div>
  </card>
</template>

<script>
import RadialProgress from '../shared/RadialProgress.vue';

import Card from '../Card/index.vue';

export default {
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  components: {
    Card,
    RadialProgress,
  },
  data() {
    return {
      onboardingTasks: [],
      loaded: false,
    };
  },
  async mounted() {
    await this.fetchOnboardingTasks();
    this.loaded = true;
  },
  methods: {
    async fetchOnboardingTasks() {
      const { records } = await this.$api.Contacts.getContactOnboardingTasks(this.contact);
      this.onboardingTasks = [...records];
    },
    displayName(info) {
      if (info.assignee.name) {
        return info.assignee.name;
      } else {
        return info.assignee.email;
      }
    },
    percentage(info) {
      return Math.floor((info.completed / info.total) * 100);
    },
  },
  computed: {
    completedOnboardingTasks() {
      return this.onboardingTasks.filter(task => task.status === 'completed');
    },
    incompleteOnboardingTasks() {
      return this.onboardingTasks.filter(task => !task.completed !== 'completed');
    },
    progressByAssignee() {
      return this.onboardingTasks.reduce((acc, task) => {
        if (!acc[task.user.email]) {
          acc[task.user.email] = {
            assignee: task.user,
            completed: 0,
            total: 0,
          };
        }
        acc[task.user.email].total++;
        if (task.status === 'completed') {
          acc[task.user.email].completed++;
        }
        return acc;
      }, {});
    },
  },
};
</script>
